import {
  RetailerCatalog,
  //   UserCatalog,
  Status,
} from "contentoh-components-library";
import moment from "moment";

import {
  servicesTranslation,
  getRegionFlag,
  handleCategories,
} from "../../_utils/helper";

export const renderColumns = () => {
  const columnsArray = [
    { name: "Reg.", flex: 1, minWidth: 60 },
    { name: "Nombre", flex: 2, minWidth: 200 },
    { name: "Orden", flex: 1, minWidth: 100 },
    { name: "UPC", flex: 1, minWidth: 100 },
    { name: "Status", flex: 1, minWidth: 60 },
    { name: "F.T.", flex: 1, minWidth: 60 },
    { name: "D.C.", flex: 1, minWidth: 60 },
    { name: "Imgs.", flex: 1, minWidth: 60 },
    { name: "Departamento", flex: 2, minWidth: 200 },
    { name: "Categoría", flex: 3, minWidth: 300 },
    { name: "Cadenas", flex: 1, minWidth: 100 },
    { name: "Marca", flex: 2, minWidth: 200 },
  ];

  return columnsArray;
};

export const getProductsToTable = (products = [], images) => {
  const productsTableArray = [];

  products.forEach((product) => {
    const { orderId, article, version, status, retailers } = product;
    const id = article?.id_article + "-" + orderId;
    const imgArray = images[article?.id_article + "-" + version];
    const element = {
      id,
      cols: [
        {
          name:
            (
              <figure>
                <img
                  style={{ height: 30, width: 30, objectFit: "contain" }}
                  src={getRegionFlag(article.country)}
                  alt={article.country}
                />
              </figure>
            ) || "-",
          flex: 1,
          minWidth: 60,
        },
        { name: <p>{article?.name}</p> || "-", flex: 2, minWidth: 200 },
        { name: <p>{orderId}</p> || "-", flex: 1, minWidth: 100 },
        { name: <p>{article.upc}</p> || "-", flex: 1, minWidth: 100 },
        { name: <Status statusType={status} />, flex: 1, minWidth: 60 },
        {
          name: <Status statusType={product.datasheet_status} />,
          flex: 1,
          minWidth: 60,
        },
        {
          name: <Status statusType={product.description_status} />,
          flex: 1,
          minWidth: 60,
        },
        {
          name: <Status statusType={product.images_status} />,
          flex: 1,
          minWidth: 60,
        },
        {
          name: <p>{handleCategories(article.category, "department")}</p>,
          flex: 2,
          minWidth: 200,
        },
        {
          name: <p>{handleCategories(article.category)}</p>,
          flex: 3,
          minWidth: 300,
        },
        {
          name:
            (
              <RetailerCatalog
                id={"retailers-" + id}
                limit={2}
                article={product}
                retailers={retailers}
              />
            ) || "-",
          flex: 1,
          minWidth: 100,
        },
        { name: <p>{product.brand || "S/M"}</p>, flex: 2, minWidth: 200 },
      ],
      gridElement: {
        images: imgArray,
        info: [
          { title: "name", value: article?.name || "-" },
          { title: "name", value: article?.upc || "-" },
          { title: "order", value: orderId || "-" },
          {
            title: "department",
            value: handleCategories(article.category, "department") || "-",
          },
          {
            title: "category",
            value: handleCategories(article.category) || "-",
          },
        ],
        status: [
          { title: "general", value: status || "-" },
          { title: "datasheet", value: product.datasheet_status || "-" },
          { title: "description", value: product.description_status || "-" },
          { title: "images", value: product.images_status || "-" },
        ],
        catalogs: {
          leftSide:
            (
              <RetailerCatalog
                id={"retailers-" + id}
                limit={2}
                article={product}
                retailers={retailers}
              />
            ) || "-",
        },
      },
      showBottom: true,
      product,
    };

    productsTableArray.push(element);
  });

  return productsTableArray;
};

export const chkOnChange = (e, product, state, setState) => {
  const tempArray = state.slice();
  if (e.target.checked) {
    tempArray.push(product);
    setState(tempArray);
  } else {
    const filteredArray = tempArray.filter(
      (item) =>
        !(
          item.orderId === product.orderId &&
          item.id_article === product.id_article
        )
    );
    setState(filteredArray);
  }
};

export const chkChecked = (product, state) => {
  const productSelected = [];
  state.forEach((prod) => {
    prod.orderId === product.orderId &&
      prod.article.id_article === product.article.id_article &&
      productSelected.push(prod);
  });
  return productSelected?.length > 0;
};

export const checkAll = (e, setState, products) => {
  const chks = document.querySelectorAll(".chk-item > input");
  e.target.checked ? setState(products) : setState([]);
  chks?.forEach((chk) => (chk.checked = e.target.checked));
};

export const chkCheckedAll = (selected, products) => {
  return selected.length === products.length;
};
